// stores/providers/providersStore.js
import { defineStore } from 'pinia';
import { api } from '../../services/api';
import { useGamesStore } from '../games/gamesStore';

export const useProvidersStore = defineStore('providers', {
  state: () => ({
    providers: [],
    selectedProvider: null,
    groupedProviders: {}
  }),

  actions: {
    async loadProviders() {
      try {
        const response = await api.get('/player/providers');
        if (response.data.success) {
          this.providers = response.data.providers;
          this.groupProvidersByCode();
        }
      } catch (error) {
        console.error('Error loading providers:', error);
      }
    },

    setSelectedProvider(provider) {
      this.selectedProvider = provider;
      
      // Importante: Usar el gamesStore para filtrar los juegos
      const gamesStore = useGamesStore();
      if (provider) {
        gamesStore.filterGamesByProvider(provider.code);
      } else {
        gamesStore.filterGamesByProvider('all');
      }
    },

   groupProvidersByCode() {
  // Original functionality
  this.groupedProviders = this.providers.reduce((grouped, provider) => {
    // Usar el código original como clave, excepto para pragmatic
    let key = provider.code;
    
    // Solo para pragmatic, usar una clave común
    if (key.toLowerCase() === 'pragmatic' || key.toLowerCase() === 'pragmaticplay') {
      key = 'pragmatic-group';
    }
    
    if (!grouped[key]) {
      grouped[key] = {
        id: provider.id,
        name: provider.name,
        code: provider.code,
        status: provider.status,
        distribution: provider.distribution,
        providers: [],
        games: [],
        distributions: []
      };
    }
    grouped[key].providers.push(provider);
    if (!grouped[key].distributions.includes(provider.distribution)) {
      grouped[key].distributions.push(provider.distribution);
    }
    grouped[key].games = [...grouped[key].games, ...(provider.games || [])];
    return grouped;
  }, {});
},

    updateProviders(providers) {
      this.providers = providers;
      this.groupProvidersByCode();
    }
  },

  getters: {
    getProvidersByCode: (state) => {
      return Object.values(state.groupedProviders);
    },
    
    getProvidersByDistribution: (state) => (distribution) => {
      return state.providers.filter(provider => 
        provider.distribution === distribution
      );
    }
  }
});